module.exports = {

  title: '物联网管理平台V3',

  logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png',

  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
    * @type {boolean} true | false
    * @description Whether need tagsView
    */
  tagsView: true,

  /**
    * @type {boolean} true | false
    * @description Whether fix the header
    */
  fixedHeader: false,

  /**
    * @type {boolean} true | false
    * @description Whether show the logo in sidebar
    */
  sidebarLogo: true,

  /**
    * @type {string | array} 'production' | ['production', 'development']
    * @description Need show err logs component.
    * The default is only used in the production env
    * If you want to also use it in dev, you can pass ['production', 'development']
    */
  errorLog: 'production',

  loginMode: 'nickname',

  loginCaptcha: 1,

  sidebarView:true // 开启通栏
}
